"use client";

import { useEffect } from "react";
import Header from "@/components/headerV2";
import ListExperiences from "@/components/listExperiences";
import Sponsors from "@/components/sponsors";
import Footer from "@/components/footer";
import BottomMenu from "@/components/bottomMenu";

export default function Experiences() {
  useEffect(() => {
    const targets = document.querySelectorAll<HTMLElement>(
      ".reveal-up, .reveal-scale, .float-soft",
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        // Large sections on mobile may never reach 20% visible at once.
        threshold: 0.05,
        rootMargin: "0px 0px -5% 0px",
      },
    );

    targets.forEach((target) => observer.observe(target));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="site-shell">
      <Header />
      <div style={{ paddingTop: 100 }} />

      <ListExperiences />

      {/*<Sponsors />*/}
      <Footer />
      <div style={{ paddingTop: 100 }} />
      <BottomMenu />
    </div>
  );
}
